import Box from '@mui/material/Box';
import {motion, MotionStyle, TargetAndTransition, Transition, VariantLabels} from 'framer-motion';
import {createPortal} from 'react-dom';

export interface ResultMotionItem {
  initial?: boolean | TargetAndTransition | VariantLabels;
  animate?: boolean | TargetAndTransition | VariantLabels;
  transition?: Transition<any>;
  style?: MotionStyle | undefined;
  text?: string;
}

/**
 * Create container for motion
 * @returns
 */
export default function createResultMotion(items: ResultMotionItem[]) {
  return createPortal(
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 9999,
        overflow: 'hidden',
        willChange: 'transform',
        transform: 'translateZ(0)', // Force hardware acceleration
      }}
    >
      {items.map((item, index) => (
        <motion.div
          // eslint-disable-next-line react/no-array-index-key
          key={`createResultMotion-motion-item-${index}`}
          initial={item.initial}
          animate={item.animate}
          transition={item.transition}
          style={item.style}
        >
          {item.text}
        </motion.div>
      ))}
    </Box>,
    document.body,
  );
}
